// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1ULBf","approved":"Status_approved__2Z4Mo","rejected":"Status_rejected__-OCAz","expired":"Status_expired__2mNrl","label":"Status_label__3iu5z"};